import StoreContainer from "./StoreContainer";
import cookies from "../helpers/cookies";

const namespace = "velaro";

type StorageKey =
  | "visitorId"
  | "engagementId"
  | "preEngagementId"
  | "isExpanded"
  | "socialData"
  | "callId"
  | "previousPage"
  | "endOfDay"
  | "eyecatcherDismissed"
  | "firstvisit"
  | "engagement_groupId";

class CookieStore {
  get(key: StorageKey) {
    const json = cookies.get(`${namespace}_${key}`);

    if (json === null || json === undefined) {
      return undefined;
    }

    try {
      return JSON.parse(json);
    } catch (err) {
      return undefined;
    }
  }

  set(key: StorageKey, value: any, options?: {}) {
    if (value === null || value === undefined) {
      this.clear(key, options);
      return;
    }

    if (StoreContainer.SettingStore.areCookiesDisabled()) {
      return;
    }

    const defaultOptions = {
      expires: 9999,
      path: "/"
    } as any;

    // Don't be alarmed if the cookieDomain setting doesn't work in IE/Edge locally.
    // Those browsers expect a TLD and fail to store cookies silently without one.
    // https://stackoverflow.com/questions/22690114/internet-explorer-11-wont-set-cookies-on-a-site#comment92933932_34766660

    const domain = StoreContainer.SettingStore.getCookieDomain();

    if (domain) {
      defaultOptions.domain = domain;
    }

    const protocol = window.parent
      ? window.parent.location.protocol
      : window.location.protocol;

    if (protocol.indexOf("https") === 0) {
      defaultOptions.secure = true;
    }

    options = { ...defaultOptions, ...options };

    cookies.set(`${namespace}_${key}`, JSON.stringify(value), options);
  }

  clear(key: StorageKey, options?: {}) {
    const defaultOptions = {
      path: "/"
    } as any;

    const domain = StoreContainer.SettingStore.getCookieDomain();

    if (domain) {
      defaultOptions.domain = domain;
    }

    options = { ...defaultOptions, ...options };

    cookies.clear(`${namespace}_${key}`, options);
  }
}

// Data used to be stored in localStorage, but we had to move back to cookies
// so data could be shared across domains.

function migrateFromLocalStorage() {
  const json = localStorage.getItem(namespace);

  if (!json) {
    return;
  }

  const context = JSON.parse(json) as any;

  Object.keys(context).forEach(key => {
    this.set(key as StorageKey, context[key]);
  });

  localStorage.removeItem(namespace);
}

migrateFromLocalStorage();

export default CookieStore;
